export const BROADCAST_CHANNEL_NAME =
  'snapchat_ads_reporting_integration_channel';
